import { useState } from "react"
import { useRecoilValue } from "recoil"
import styled, { keyframes } from "styled-components"
import { langState } from "../../../state/langState"
import { Heading2, T5 } from "../../../style/constant"


interface ServiceProps {
  idx:number
  title :string,
  desc:string,
  defaultImg:string,
  hoverImg:string,
  logoImg:string
}

const Service = ({idx,title,desc,defaultImg,hoverImg,logoImg}:ServiceProps) => {
  const currentLang = useRecoilValue(langState)

  const [hover,setHover] = useState(false)
  const handleMouseEnter = () => {
    setHover(true)
  }

  const handleMouseLeave = () => {
    setHover(false)
  }

  return(
    <Container idx={idx} onMouseEnter={handleMouseEnter} onMouseLeave= {handleMouseLeave} >
      {/* <DefaultImg idx={idx} isHover = {hover} src={defaultImg} alt="defaultImg" /> */}
      <HoverImg idx={idx} isHover = {hover} src={hoverImg} alt="hoverImg" />
      <Text currentLang = {currentLang} idx={idx}>
        <Title currentLang={currentLang}>{title}</Title>
        <SubTitle currentLang={currentLang}> {desc}</SubTitle>
        <Logo isHover={hover} src={logoImg} alt="service_logo"/>
      </Text>
      {/* <Background src={'/img/rectangle.png'} alt="" isHover = {test}/> */}
    </Container>
  )
}


export default Service

type TextProps = {
  currentLang:boolean
}

type ContainerProps = {
  idx:number
}

type ImgProps = {
  isHover : boolean
  idx:number
}

type TextWrapperProps = {
  currentLang:boolean
  idx:number
}

type LogoProps = {
  isHover:boolean
}



const Container = styled.div<ContainerProps>`
  position:relative;
  display: flex;
  overflow:hidden;
  flex-direction: ${props => props.idx %2 === 0 ? `row`:`row-reverse`};
  border: 1px solid transparent;
  border-radius: 47px;
  /* border-image:  ${props => props.idx %2 === 0 ? `linear-gradient(to right,#020203, #fff ) 1;`:`linear-gradient(to left,#020203, #fff) 1;`}; */
  background:${props => props.idx %2 === 0 ? `linear-gradient(90deg, #020203 71.67%, rgba(2, 2, 3, 0) 96.38%);` :`linear-gradient(270deg, #020515 58.42%, rgba(2, 5, 21, 0) 100.53%);`};
  margin:0 0 40px 0;
  width:1200px;
  height:581px;
  /* background: url(/img/rectangle.png) no-repeat right bottom/60%;  */
  /* border-image:linear-gradient(to right, #fff 0%, #0F192D 100%); */
  /* border-image-slice: 1; */
  `
const HoverImg = styled.img<ImgProps>`
  position: absolute;
  ${props=> props.idx % 2 === 0 ? `right:0;`:`left:0;`}
  top:${props => props.isHover ?`0;`:`20px;`};
  width:${props => props.idx === 0 ? `813px`:`735px`};
  height:100%;
  filter:${props => props.isHover ? `grayscale(0%);`: `grayscale(100%);`};
  transition:0.5s;
`

const Text = styled.div<TextWrapperProps>`
  ${props=>props.idx % 2  ===0 ?`margin-left:103px;`:`margin-right:103px;`}
  display:flex;
  flex-direction:column;
  justify-content:center;
`

const Title = styled.p<TextProps>`
  white-space: pre-line;
  margin: 0 0 15px 0;
  ${props=>props.currentLang ? `${Heading2}`:`${T5};`}
`

const SubTitle = styled.p<TextProps>`
  white-space: pre-line;
  font-size:17px;
  color:rgba(255,255,255,0.8);
  margin: 0 0 78px 0;
  line-height: 151%;
`

const Logo = styled.img<LogoProps>`
  width:163px;
  height:50px;
  filter:${props => props.isHover ? `grayscale(0%); `: `grayscale(100%);`};
  transition:filter 0.5s;
`
